<template>
  <transition name="modal-fade">
    <div class="modal-overlay" v-if="visible">
      <div class="modal-container modal-lg">
        <div class="modal-body">
          <h5 class="modal-title">Pernyataan</h5>

          <div class="modal-scroll">
            <ol class="modal-list">
              <li>
                Saya menyatakan dan menjamin bahwa saya tidak pernah atau tidak
                akan terlibat baik secara langsung maupun tidak langsung dalam
                transaksi yang melanggar hukum selama bekerja di perusahaan,
                termasuk namun tidak terbatas pada perjudian online, pendanaan
                aktivitas illegal, pencucian uang atau transaksi terlarang
                lainnya.
              </li>
              <li>
                Saya memahami bahwa transaksi sebagaimana disebutkan pada poin 1
                di atas adalah perbuatan melanggar hukum dan bertentangan dengan
                peraturan perundang-undangan yang berlaku di Indonesia serta
                peraturan perusahaan.
              </li>
              <li>
                Apabila di kemudian hari terbukti bahwa pernyataan saya ini
                tidak benar dan terlibat dalam transaksi yang melanggar hukum
                sebagaimana disebutkan pada poin 1 tersebut di atas maka saya
                bersedia untuk dikenakan sanksi sesuai dengan ketentuan
                sebagaimana diatur dalam peraturan perundang-undangan yang
                berlaku dan/atau peraturan perusahaan serta segala kerugian yang
                timbul atas pernyataan saya ini menjadi tanggung jawab saya
                sepenuhnya.
              </li>
            </ol>

            <label class="tnc-checkbox">
              <input type="checkbox" v-model="isAgree" />
              <span>
                Saya telah membaca, mengerti, dan menyatakan tidak akan terlibat
                dalam transaksi yang melanggar hukum
              </span>
            </label>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" v-if="!isAgree">
            Lanjutkan
          </button>
          <button
          v-else
            class="btn btn-info"
            @click="handleLanjutkanClicked"
          >
            <span :style="{ opacity: isLoadingBtn ? 0 : 1 }">Lanjutkan</span>
            <span v-if="isLoadingBtn" class="spinner-overlay">
              <span class="spinner"></span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "TnCModal",
  data() {
    return {
      visible: false,
      isAgree: false,
      isLoadingBtn: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
      document.body.style.overflow = "hidden";
    },
    hide() {
      this.visible = false;
      document.body.style.overflow = "";
    },
    handleLanjutkanClicked() {
      if(!this.isAgree) return;
      this.isLoadingBtn = true;
      this.$emit("accTnC", true);
    },
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-container {
  background: #fff;
  border-radius: 15px;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

@media (max-width: 992px) {
  .modal-container {
    max-width: 600px;
  }
}

@media (max-width: 576px) {
  .modal-container {
    max-width: calc(100% - 32px);
    margin: 0 16px;
  }
}

.modal-body {
  padding: 16px 50px;
}

.modal-title {
  font-size: 20px;
  font-weight: bold;
  padding: 15px;
}

.modal-scroll {
  line-height: 1.6;
  max-height: 300px;
  overflow-y: auto;
}

.modal-footer {
  padding: 12px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #eee;
}

.modal-list {
  font-size: 17px;
  color: #6c757d;
}

.modal-list li {
  padding-bottom: 10px;
}

.btn {
  padding: 8px 30px;
  border-radius: 6px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  position: relative;
}

.btn-info {
  background: #17a2b8;
  color: #fff;
}

.btn-secondary {
  background: #adb5bd;
  color: #fff;
}

.btn-sm .spinner {
  width: 12px;
  height: 12px;
  border-width: 2px;
}

.spinner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.tnc-checkbox {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  cursor: pointer;
}

.tnc-checkbox span {
  font-size: 16px;
  font-weight: bold;
}

.tnc-checkbox input {
  accent-color: #17a2b8;
  width: 20px;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
